"use client";

import React, { useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const experiences = [{
  id: 1,
  title: "Private Yacht Charter",
  description: "Sail the Aegean sea in absolute luxury with a dedicated crew and private chef catering to your every whim.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/yacht_charter.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/yacht_charter.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/yacht_charter.png-wvc-sizes",
  link: "/experiences/yacht-charter"
}, {
  id: 2,
  title: "Desert Oasis Retreat",
  description: "Experience the profound silence of the dunes in a secluded, ultra-luxury tented camp under the stars.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/desert_oasis.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/desert_oasis.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/desert_oasis.png-wvc-sizes",
  link: "/experiences/desert-retreat"
}, {
  id: 3,
  title: "Alpine Heli-Skiing",
  description: "Access untouched powder on remote peaks with your private helicopter and world-class mountain guides.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/alpine_heli.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/alpine_heli.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/alpine_heli.png-wvc-sizes",
  link: "/experiences/heli-skiing"
}];
export default function ExclusiveExperiences() {
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      let progress = 0;
      if (rect.top <= viewportHeight && rect.bottom >= 0) {
        progress = 1 - rect.bottom / (viewportHeight + rect.height);
      }
      const parallaxValue = (progress - 0.5) * 40;
      sectionRef.current.style.setProperty('--parallax-y', `${parallaxValue}px`);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section id="exclusive-experiences" className="bg-background py-24 md:py-32 overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-6 max-w-7xl">
        {}
        <div className="dark">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 lg:gap-10">
            {experiences.map((exp, i) => <div key={exp.id} data-index={i} className="md:[&:nth-child(2)]:translate-y-10 transition-transform duration-700 ease-out">
                <Card className="bg-card border-none rounded-none h-full flex flex-col overflow-hidden group">
                  <div className="overflow-hidden">
                    <AspectRatio ratio={3 / 4}>
                      <img src={exp.imageSrc} data-wvc-srcset={exp.imageSrcset} data-wvc-sizes={exp.imageSizes} alt={exp.title} loading="lazy" className="w-full h-full object-cover scale-110 transition-transform duration-1000 ease-out group-hover:scale-105" style={{
                    transform: 'translateY(var(--parallax-y, 0)) scale(1.15)'
                  }} />
                    </AspectRatio>
                  </div>
                  
                  <CardHeader className="pt-8 pb-4 px-6 md:px-8">
                    <CardTitle className="font-serif font-semibold text-4xl text-secondary leading-tight">
                      {exp.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="px-6 md:px-8 flex-grow">
                    <CardDescription className="font-sans text-base text-card-foreground/90 leading-relaxed">
                      {exp.description}
                    </CardDescription>
                  </CardContent>
                  
                  <CardFooter className="px-6 md:px-8 pb-8 pt-0">
                    <Link to={exp.link} className="font-sans text-sm uppercase tracking-wider text-secondary relative inline-block pb-1 after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-full after:bg-secondary after:origin-bottom-right after:scale-x-0 hover:after:origin-bottom-left hover:after:scale-x-100 after:transition-transform after:duration-300">
                      Learn More
                    </Link>
                  </CardFooter>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}